import React from 'react';

export function Card({ className = '', children }) {
  return (
    <div className={`rounded-2xl bg-gray-800 text-white shadow p-4 ${className}`}>
      {children}
    </div>
  );
}

export function CardContent({ className = '', children }) {
  return (
    <div className={`mt-2 ${className}`}>
      {children}
    </div>
  );
}
